import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.83 2.92',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M3.34,2.26h-2a.07.07,0,0,1-.06,0L.81.8h0L.62.12H.06A.06.06,0,0,1,0,.06.06.06,0,0,1,.06,0H.67s0,0,0,0L.91.73H3.77s0,0,0,0,0,0,0,.05L3.4,2.22A.07.07,0,0,1,3.34,2.26Zm-2-.12H3.3L3.69.84H1Z"
        />
        <path
          fill={fill}
          d="M1.49,2.92a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26.25.25,0,0,1,.26.26A.26.26,0,0,1,1.49,2.92Zm0-.41a.15.15,0,0,0-.14.15.14.14,0,0,0,.28,0A.15.15,0,0,0,1.49,2.51Z"
        />
        <path
          fill={fill}
          d="M3.14,2.92a.26.26,0,0,1-.26-.26.26.26,0,0,1,.52,0A.26.26,0,0,1,3.14,2.92Zm0-.41A.15.15,0,0,0,3,2.66a.14.14,0,0,0,.28,0A.15.15,0,0,0,3.14,2.51Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
